import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { useProjectTreeStore } from 'store/projectContract.store';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import InlineInput from 'components/common/inlineInput/inlineInput';

import { CustomizedFormErrorMessage } from 'components/common';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/CardHeader/CardHeader.module.scss';

export const CardHeader = ({ title }) => {
    const { project, contract } = useProjectTreeStore();

    const {
        control,
        formState: { errors },
        watch,
    } = useFormContext<Risk>();

    const uid = watch('uid');
    return (
        <div className={classes.cardHeaderContainer}>
            <div className={classes.row}>
                <div className={classes.inputWrapper}>
                    <span className={classes.inputLabel}>Project *:</span>
                    <div className={classes.inputValue}>{project?.title}</div>
                </div>
                <div className={classes.inputWrapper}>
                    <span className={classes.inputLabel}>Sub-Program *:</span>
                    <div className={classes.inputValue}>{contract?.title}</div>
                </div>
                {uid ? (
                    <div className={classes.inputWrapper}>
                        <span className={classes.inputLabel}>Risk ID *:</span>
                        <div className={classes.inputValue}>{uid}</div>
                    </div>
                ) : null}
            </div>
            <div>
                <Controller
                    render={({ field }) => (
                        <InlineInput
                            handleChange={field.onChange}
                            {...field}
                            placeholder={'Enter Risk Name'}
                            value={field.value}
                        />
                    )}
                    name={`name`}
                    control={control}
                    rules={{
                        required: 'Name is required',
                        minLength: { value: 2, message: 'Name must be at least 2 characters' },
                        maxLength: { value: 100, message: 'Name must be no more than 100 characters' },
                    }}
                />
                {errors.name && <CustomizedFormErrorMessage text={errors.name.message} />}
            </div>
            <div className={classes.cardType}>{title}</div>
        </div>
    );
};
